import type { RosterActivityEvent, RosterActivityKind } from "./types";
import type { RosterMovementBand } from "./types";

export const JOINED_SECTION_KINDS = ["JOINED_SECTION"] as const satisfies readonly RosterActivityKind[];

export const LEFT_SECTION_KINDS = ["LEFT_SECTION", "RETIRED"] as const satisfies readonly RosterActivityKind[];

export const IN_MEMORIAM_KINDS = ["DECEASED"] as const satisfies readonly RosterActivityKind[];

export const ROSTER_MOVEMENT_KINDS = [
  ...JOINED_SECTION_KINDS,
  ...LEFT_SECTION_KINDS,
  ...IN_MEMORIAM_KINDS
] as const satisfies readonly RosterActivityKind[];

export type RosterMovementKind = (typeof ROSTER_MOVEMENT_KINDS)[number];

const KIND_TO_BAND: Partial<Record<RosterActivityKind, RosterMovementBand>> = {
  JOINED_SECTION: "joined",
  LEFT_SECTION: "left",
  RETIRED: "left",
  DECEASED: "inMemoriam"
};

export function isRosterMovementKind(kind: RosterActivityKind): kind is RosterMovementKind {
  return KIND_TO_BAND[kind] !== undefined;
}

export function getMovementBand(kind: RosterMovementKind): RosterMovementBand;
export function getMovementBand(kind: RosterActivityKind): RosterMovementBand | null;
export function getMovementBand(kind: RosterActivityKind): RosterMovementBand | null {
  return KIND_TO_BAND[kind] ?? null;
}

export function isRosterMovementEvent(event: RosterActivityEvent): boolean {
  return getMovementBand(event.kind) !== null;
}

export function filterEventsByBand(events: RosterActivityEvent[], band: RosterMovementBand): RosterActivityEvent[] {
  return events.filter((event) => getMovementBand(event.kind) === band);
}
